import { STORE_SIDEBAR, STORE_STATUS_INITIALIZED } from 'constants/store'
import { createGenericSlice, GenericState } from 'stores/generics'

export type SidebarState = {
  opened: boolean
}

type State = GenericState<
  SidebarState,
  {
    data: SidebarState
    error_id: string
  }
>

export const initialState: State = {
  data: {
    opened: false,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

const userSlice = createGenericSlice({
  name: STORE_SIDEBAR,
  initialState,
  reducers: {
    openSidebar: (state) => {
      state.data.opened = true
    },
    closeSidebar: (state) => {
      state.data.opened = false
    },
    toggleSidebar: (state) => {
      state.data.opened = !state.data.opened
    },
  },
})

const { actions, reducer } = userSlice

const { openSidebar, closeSidebar, toggleSidebar } = actions

export { openSidebar, closeSidebar, toggleSidebar }

export default reducer
